/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M43 14c-15.98 0-29 13.02-29 29s13.02 29 29 29c6.91 0 13.258-2.441 18.25-6.5l19.625 19.625c1.172 1.172 3.078 1.172 4.25 0s1.172-3.047 0-4.219L65.5 61.281a28.862 28.862 0 006.5-18.28c0-15.98-13.02-29-29-29zm0 6c12.738 0 23 10.262 23 23S55.738 66 43 66 20 55.738 20 43s10.262-23 23-23z"/>'
  }
})
